<div class="notifications-button">
    <button
        type="button"
        class="notifications-button__trigger"
        [class.notifications-button__trigger--active]="isOpen()"
        [attr.aria-expanded]="isOpen()"
        aria-haspopup="true"
        [attr.aria-label]="
            (displayedNotifications().length > 0
                ? 'TOP-NAVBAR.NOTIFICATIONS-AVAILABLE'
                : 'TOP-NAVBAR.NO-NOTIFICATIONS'
            ) | translate
        "
        (click)="toggleMenu()"
    >
        <span class="material-symbols-outlined notifications-button__icon">
            notifications
        </span>
        @if (displayedNotifications().length > 0) {
            <span class="notifications-button__badge"></span>
        }
    </button>

    @if (isOpen()) {
        <div class="notifications-button__panel" role="menu">
            @if (displayedNotifications().length === 0) {
                <div class="notifications-button__empty">
                    <i class="grey-text">{{
                        'TOP-NAVBAR.NO-NOTIFICATIONS' | translate
                    }}</i>
                </div>
            } @else {
                <ul class="notifications-button__list">
                    @for (
                        notification of displayedNotifications();
                        track notification.title
                    ) {
                        <li class="notifications-button__item">
                            <app-ui-expansion-panel
                                [expanded]="isExpanded(notification.title)"
                                [isExpansible]="!!notification.summary"
                                (expandedChange)="
                                    onExpandedChange(notification.title, $event)
                                "
                            >
                                <div
                                    panelHeader
                                    class="notifications-button__item-header"
                                >
                                    <span
                                        class="material-symbols-outlined notifications-button__item-icon"
                                    >
                                        info
                                    </span>
                                    <span
                                        class="notifications-button__item-title"
                                    >
                                        {{ notification.title }}
                                    </span>
                                </div>
                                @if (notification.summary) {
                                    <div
                                        panelContent
                                        class="notifications-button__item-body"
                                    >
                                        <i
                                            class="grey-text"
                                            [innerHTML]="
                                                htmlSanitizerService.getSanitizedText(
                                                    notification.summary!
                                                )
                                            "
                                        ></i>
                                        @if (
                                            notification.downtimeStart &&
                                            notification.downtimeEnd &&
                                            notification.datacenters
                                        ) {
                                            <i class="grey-text">{{
                                                platformStatusService.getMaintenanceInfo(
                                                    notification
                                                )
                                            }}</i>
                                        }
                                    </div>
                                }
                            </app-ui-expansion-panel>
                        </li>
                    }
                </ul>
            }
        </div>
    }
</div>
